//imports
import { all } from 'redux-saga/effects';

//Views
import createEditDealerSagas from 'Modules/dealers/views/.components/createEditDealer/redux/saga';
import dealerOverviewSagas from 'Modules/dealers/views/overview/redux/saga';

//merge sagas
export default function* rootSaga() {
    yield all([
        createEditDealerSagas(),
        dealerOverviewSagas()
    ]);
}